import React from "react";
import RadioButton from "./RadioButton";

export interface IOption {
  label: string;
  disabled?: boolean;
  value: string | number;
}

export interface IOptionGroup {
  label?: string;
  options: IOption[];
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  direction?: "row" | "column";
  value: string | number;
  hideErrorMessage?: boolean;
  error?: string;
}

const RadioButtonGroup = ({
  label,
  options,
  direction = "row",
  onChange,
  value: RadioGroupValue,
  error,
  hideErrorMessage = false,
}: IOptionGroup) => {
  return (
    <div className="my-[1.4rem]">
      <div className="mb-4 text-[1.8rem] font-semibold">{label}</div>
      <div
        className="flex gap-4"
        style={{
          flexDirection: direction,
          flexWrap: direction === "row" ? "wrap" : "nowrap",
        }}
      >
        {options.map(({ label, disabled, value }: IOption) => {
          const shortenedOptionLabel = label?.replace(/\s+/g, "");
          const optionId = `radio-option-${shortenedOptionLabel}`;
          return (
            <RadioButton
              value={value}
              label={label}
              id={optionId}
              disabled={disabled}
              checked={RadioGroupValue === value}
              onChange={onChange}
              key={optionId}
            />
          );
        })}
      </div>
      {!hideErrorMessage && error && (
        <div className="mt-[1rem] text-small text-left text-error">{error}</div>
      )}
    </div>
  );
};

export default RadioButtonGroup;
